import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { VALID_FUND_CHART_DATE_ZOOM_OPTIONS } from 'ChartApp/ts/features/fundamental-chart/constants';
import { HISTORICAL_DATA_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { ChartDateZoom } from 'ChartApp/ts/enums/chart-common.enum';
import { FundChartDateZoomCustomCssClasses, FundChartZoomOption } from 'ChartApp/ts/interfaces/fund-chart.interface';

import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';

import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';

@Component({
    standalone: false,
    selector: 'ycn-fund-chart-date-zoom',
    templateUrl: './fund-chart-date-zoom.template.html',
})
export class FundChartDateZoomComponent implements OnInit {
    @Input('customCssClasses') customCssClasses: FundChartDateZoomCustomCssClasses = {};

    @Input('zoomOptions') zoomOptions: FundChartZoomOption[] = VALID_FUND_CHART_DATE_ZOOM_OPTIONS;

    @Input('zoom') zoom: ChartDateZoom | '' = ChartDateZoom.CHART_ZOOM_ONE_YEAR;

    @Input() showResetOption: boolean = false;

    @ViewChild('featureNeededModal') featureNeededModal!: FeatureNeededComponent;

    @Output() selectZoomOptionHandler: EventEmitter<FundChartZoomOption> = new EventEmitter<FundChartZoomOption>();

    @Output() resetZoomHandler: EventEmitter<void> = new EventEmitter<void>();

    userHasHistoricalDataFeature: boolean;

    constructor(private featureService: FeatureService) {
        this.userHasHistoricalDataFeature = this.featureService.userHasFeatures([HISTORICAL_DATA_FEATURE]);
    }

    ngOnInit(): void {
        this.zoomOptions = this.createZoomOptions();
    }

    createZoomOptions(): FundChartZoomOption[] {
        return this.zoomOptions.map((option) => {
            const newOption = { ...option };
            // disable historical data options if the user is missing the required feature
            newOption.enabled =
                ![
                    ChartDateZoom.CHART_ZOOM_TEN_YEAR,
                    ChartDateZoom.CHART_ZOOM_FIFTEEN_YEAR,
                    ChartDateZoom.CHART_ZOOM_MAX,
                ].includes(option.value as ChartDateZoom) || this.userHasHistoricalDataFeature;
            return newOption;
        });
    }

    select(event: Event, zoomOption: FundChartZoomOption): void {
        event.preventDefault();
        if (!zoomOption.enabled) {
            this.featureNeededModal.openModal(HISTORICAL_DATA_FEATURE);
            return;
        }
        this.selectZoomOptionHandler.emit(zoomOption);
    }
}
